export const VALIDATORS_CONSTANT = {
  PASSWORD_MIN_LENGTH: 8,
  PHONE_MIN_LENGTH: 10,
  FIRST_NAME_MIN_LENGTH: 3,
  LAST_NAME_MIN_LENGTH: 3,
  MAX_REASON_LENGTH: 490,
  MAX_OFFER_NAME_LENGTH: 150,
  MIN_OFFER_NAME_LENGTH: 3,
  MAX_OFFER_SUMMARY_LENGTH: 100,
  MIN_OFFER_SUMMARY_LENGTH: 3,
  MAX_OFFER_DESCRIPTION_LENGTH: 255,
  MIN_OFFER_DESCRIPTION_LENGTH: 3,
  MAX_OFFER_TERMS_LENGTH: 10290,
  MIN_OFFER_TERMS_LENGTH: 10,
  MAX_OFFER_REDEMPTION_MESSAGE_LENGTH: 255,
  MAX_OFFER_PRICE: 1_000_000_000_000,
  MAX_OFFER_PRICE_NUMBER: 1000000000000,

  MAX_AMBASSADOR_CODE_LENGTH: 10,

  MAX_OFFER_CODE_LENGTH: 12,
  MAX_OFFER_CODE_COUNT: 100000,
  MIN_OFFER_CODE_LENGTH: 6,
  MIN_OFFER_CODE_POOL_LENGTH: 6,
  MAX_OFFER_CODE_POOL_LENGTH: 20,
  MAX_CODE_PREFIX_LENGTH: 4,

  MAX_BRAND_DESCRIPTION_LENGTH: 1000,

  MAX_CAMPAIGN_NAME_LENGTH: 200,
  MAX_CAMPAIGN_PROMOTION_TITLE_LENGTH: 200,
  MAX_CAMPAIGN_PROMOTION_DESCRIPTION_LENGTH: 500,

  LINK_LOCATION_MIN_LENGTH: 3,
};
